import { useEffect, useState } from "react";

const OPEN_HOUR = 9;
const CLOSE_HOUR = 20;

const computeOpen = () => {
    const h = new Date().getHours();
    return h >= OPEN_HOUR && h < CLOSE_HOUR;
};

export const useIsOpenNow = () => {
    const [open, setOpen] = useState(computeOpen);
    useEffect(() => {
        const t = setInterval(() => setOpen(computeOpen()), 60000);
        return () => clearInterval(t);
    }, []);
    return open;
};

const LiveStatus = ({ dark = false, testid = "live-status" }) => {
    const open = useIsOpenNow();
    return (
        <span
            data-testid={testid}
            className={`inline-flex items-center gap-2.5 rounded-full border px-4 py-2 text-xs font-bold uppercase tracking-[0.15em] ${
                dark ? "border-white/25 bg-white/10 text-white" : "border-black/10 bg-white text-night shadow-sm"
            }`}
        >
            <span className="relative flex h-2.5 w-2.5">
                {open && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />}
                <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${open ? "bg-green-500" : "bg-amber-400"}`} />
            </span>
            {open ? "Disponibles maintenant : décroché immédiat" : "Fermé : rappel dès 9h00, 7j/7"}
        </span>
    );
};

export default LiveStatus;
